import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { getMutualFundsFundOrderPath } from '../../../../../../../../../../features/mutual-funds/fund-order/mutual-funds-fund-order-routing';
import { AccountBreadcrumb } from '../../../../../../../../../../features/registration/account/account-breadcrumb';

export const Route = createFileRoute('/_app/_clearing-core/registration/account/$accountId/_account/_detail/order/mutual-fund/_mutual-fund')({
  preload: false,
  loader: ({ params }) =>
    ({
      breadcrumb: buildBreadcrumb({
        id: `account-${params.accountId}-mutual-fund-order-list`,
        label: <AccountBreadcrumb accountId={params.accountId} displayIdOnly />,
        to: getMutualFundsFundOrderPath({ kind: 'list', keys: { accountId: params.accountId } }),
      }),
    }) satisfies AggregateBreadcrumb,
});
